import { request } from "@/lib/request";
import { SubscriptionTierType } from "@/lib/types";
import { useQuery } from "@tanstack/react-query";

export const useGetTiers = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery<SubscriptionTierType[]>({
    queryKey: ["payment", "tiers"],
    enabled,
    queryFn: async () => {
      const res = await request.get(`/payment/tiers`).catch(err => {
        throw new Error(
          err.response?.data.message
            ? err.response?.data.message
            : "Failed to fetch subscription tiers.",
        );
      });

      return res.data;
    },
  });
};
